import { createContext } from "react";

import { ExchangeRates } from "../currency";

interface ExchangeRatesContextLoadingProps {
  isLoading: true;
  exchangeRates: undefined;
}

interface ExchangeRatesContextLoadedProps {
  isLoading: false;
  exchangeRates: ExchangeRates;
}

type ExchangeRatesContextProps = ExchangeRatesContextLoadedProps
  | ExchangeRatesContextLoadingProps;

// @ts-ignore
const ExchangeRatesContext = createContext<ExchangeRatesContextProps>();

export default ExchangeRatesContext;
export {
  ExchangeRatesContextProps
};
